<template>
  <div v-if="$store.state.isLogin" class="md:flex flex-row bg-white w-screen h-screen">
    <HeaderLayout/>
    <div class="md:h-screen overflow-y-auto justify-center w-full">
      <div class="flex fixed flex-row items-center shadow-md h-16 w-screen px-2 mb-2 bg-primary z-30">
        <button @click="toggleMenu" class="ico-menu w-8 h-8 bg-white"></button>
        <h1 class="text-lg uppercase font-bold mx-5 w-9/12 text-white">{{ pageName }}</h1>
        <button class="hidden gap-2 align-items-center justify-end text-white font-semibold" @click="logout">{{ this.profile ? JSON.parse(this.profile || {})?.name || "" : "" }}<span class="ico-logout w-6 h-6 bg-white"></span></button>
      </div>
      <div class="mx-2 pt-20">
        <slot></slot>
      </div>
    </div>
  </div>
  <slot v-else></slot>
</template>

<script>
import HeaderLayout from '../components/Header.vue'
export default {
  name: "DefaultLayout",
  components: {
    HeaderLayout
  },
  computed: {
    pageName(){
      let name = this.$route.name
      if(this.$route.params.id){
        if(this.$route.params.id == "new"){
          name = `new ${name.split('-')[0]}`
        }else{
          name = `edit ${name.split('-')[0]}`
        }
      }
      return name;
    }
  },
  methods: {
    logout(){
      this.$store.commit("setToken", null);
      this.$store.commit("setProfile", null);
      this.$store.commit("toggleLogin");
      window.location.href = "/login"
    }
  }
}
</script>
